
import XTable from 'vux/src/components/x-table/index.vue'

import {mapMutations} from 'vuex'
export default {
name: 'ChronicKidneyDisease_CKD',
components: {
XTable
},
created() {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad']),
},
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/ChronicKidneyDisease_CKD.vue